import { FC, useEffect, useState } from 'react';
import LottieWrapper from './LottieWrapper';
import { ENV_CONFIG } from 'config/environment';
import { defaultOptions, LottieProps } from './commonOptions';
import * as animationBlueOrbs from '../../assets/json/blueOrbs.json';
import {
  BlurredBackgroundProfileCard,
  ChildrenContainerProfileSection,
  ImpactOrbsContainer,
} from './styled';
import { BREAKPOINTS } from 'constants/breakpoints';

const LottieOrbs: FC<LottieProps> = ({ children }) => {
  const [lottieStyle, setLottieStyle] = useState({
    borderTopRightRadius: 20,
    borderBottomRightRadius: 20,
    borderBottomLeftRadius: 0,
    position: 'absolute' as any,
  });

  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    // Fetch the JSON file from the URL
    const fetchAnimationData = async () => {
      try {
        const response = await fetch(`${ENV_CONFIG().CLOUD_STORAGE.URL}/json/blueOrbs.json`);
        const jsonData = await response.json();
        setAnimationData(jsonData);
      } catch {
        setAnimationData(animationBlueOrbs);
      }
    };

    fetchAnimationData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= BREAKPOINTS.TABLET) {
        setLottieStyle({
          borderTopRightRadius: 0,
          borderBottomRightRadius: 20,
          borderBottomLeftRadius: 20, // Add left radius when width <= 1000px
          position: 'absolute',
        });
      } else {
        setLottieStyle({
          borderTopRightRadius: 20,
          borderBottomRightRadius: 20,
          borderBottomLeftRadius: 0, // Remove left radius for larger widths
          position: 'absolute',
        });
      }
    };

    handleResize(); // Run on mount
    window.addEventListener('resize', handleResize); // Listen to window resize
    return () => window.removeEventListener('resize', handleResize); // Cleanup on unmount
  }, []);

  return (
    <ImpactOrbsContainer>
      <BlurredBackgroundProfileCard />
      {animationData && (
        <LottieWrapper
          options={defaultOptions(animationData)}
          style={lottieStyle}
          isClickToPauseDisabled={true}
        />
      )}
      <ChildrenContainerProfileSection>{children}</ChildrenContainerProfileSection>
    </ImpactOrbsContainer>
  );
};

export default LottieOrbs;
